import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const resetPasswordAction = {
    ...operations,
    ...selectors,
};

export {
    resetPasswordAction,
};
export default {
    [namespace]: reducer,
};
